import { Guid } from "@syncfusion/ej2/pdf-export";

export class ClientQpInfoBO {
    orderColumn: string = "clientName";
    orderType: string = "DESC";
    pageitem: number = 10;
    currentpageno: number = 1;
    field: string = "clientName";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "contains";
    type: string = "string";
    employeeId: Guid;
    LocationID: Guid;
    clientId: Guid;
    AgencyID: Guid;
    statusLid: Guid;
  }
  export class QPfilter {
    Client: number = 0;
    QPEMP: number = 0;
    Status: number = 0;
  }
  
  export class ClientRelationshipReportBo {
    statusLid: Guid ;
    clientId: Guid ;
    employeeId: Guid ;
    supervisorId: Guid ;
    relationshipTypeLid : Guid ;
    locationID: Guid ;
    currentpageno: number = 1;
    pageitem: number = 10;
    orderColumn: string = "clientName";
    orderType: string = "asc";
    field: string = "clientName";
    value: string = "";
    matchCase: boolean;
    operator: string = "contains";
    type: string = "string";
    languageTypeLid: any;
    clientTypeLid: Guid ;
    // clientPCATypeLid: Guid ;
  }
  
  export class SupervisingAndQPMapBO {
    id: Guid = "00000000-0000-0000-0000-000000000000";
    supervisingProviderId: any = "00000000-0000-0000-0000-000000000000";
    supervisingProvider: string ;
    qpEmployeesId: any="00000000-0000-0000-0000-000000000000";
    qpEmployees: string ;
    statusLid: Guid;
    activeDate : string ;
    isActiveDateModified: boolean;
    inActiveDate: string ;
  }
  export class RequestSupervisingAndQPMapBO {
    supervisingProviderId: Guid="00000000-0000-0000-0000-000000000000";
    qpEmployeesId: Guid="00000000-0000-0000-0000-000000000000";
    statusLid: Guid ;
    activeDate : string ;
    isActiveDateModified: boolean;
    inActiveDate: string ;
    orderColumn: string;
    orderType: string;
    pageitem: number=10;
    currentpageno: number=1;
    agencyId: Guid;
    field: string = 'qpEmployees';
    value: string = '';
    operator: string = 'startswith';
    type: string = "string";
  }
  